import React from "react";

import {
  Checkbox as MuiCheckBox,
  CheckboxProps as MuiCheckboxProps,
} from "@mui/material";
import styled from "@mui/material/styles/styled";

import { lightOrDark } from "@app/embedded/theme/utils";

import { CheckedIcon, IndeterminateCheckIcon, UncheckedIcon } from "./icons";

interface CheckboxProps extends MuiCheckboxProps {
  variant?: "outlined" | "filled";
}

const StyledCheckbox = styled<React.FC<CheckboxProps>>(
  ({ variant: _v, ...props }) => <MuiCheckBox {...props} />
)(({ variant, theme }) => ({
  "& .checkbox__icon": {
    borderColor: theme.palette.shades.neutral[200],
    backgroundColor: theme.palette.background.default,
  },
  ...(variant === "outlined" && {
    "& .MuiTouchRipple-child": {
      backgroundColor: theme.palette.shades.neutral[300],
    },
    "& .checkbox__icon--checked__icon": {
      color: lightOrDark("#000", "#FFF")(theme),
    },
  }),
  ...(variant === "filled" && {
    "& .MuiTouchRipple-child": {
      backgroundColor: theme.palette.shades.neutral[300],
    },
    "& .checkbox__icon--checked, .checkbox__icon--indeterminate": {
      borderColor: theme.palette.shades.primary[500],
    },
    "& .checkbox__icon--checked__icon, .checkbox__icon--indeterminate__icon": {
      backgroundColor: theme.palette.shades.primary[500],
      color: "#FFF",
    },
    ".checkbox__icon--indeterminate__icon": {
      textAlign: "center",
      width: "100%",
    },
  }),
}));

const Checkbox = ({ variant = "outlined", ...props }: CheckboxProps) => (
  <StyledCheckbox
    checkedIcon={props.checkedIcon ?? <CheckedIcon />}
    icon={props.icon ?? <UncheckedIcon />}
    indeterminateIcon={<IndeterminateCheckIcon />}
    variant={variant}
    {...props}
  />
);

export default Checkbox;
